import type { GetStaticProps } from 'next'
import type { FC, ReactNode } from 'react'
import type { JournalPost } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/home/hero'
import { Statement } from '@/components/home/statement'
import { Principles } from '@/components/home/principles'
import { Routine } from '@/components/home/routine'
import { Ingredients } from '@/components/home/ingredients'
import { Contrast } from '@/components/home/contrast'
import { Results } from '@/components/home/results'
import { Community } from '@/components/home/community'
import { OrderSection } from '@/components/commerce/order-section'
import { Faq } from '@/components/home/faq'
import { Social } from '@/components/home/social'
import { JournalPreview } from '@/components/home/journal-preview'
import { getJournalPosts } from '@/lib/journal'

interface HomeProps {
    posts: JournalPost[]
}

const Home: FC<HomeProps> = ({ posts }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Hero />
            <Statement />
            <Principles />
            <Routine />
            <Ingredients />
            <Contrast />
            <Results />
            <Community />
            <OrderSection />
            <Faq />
            <Social />
            <JournalPreview posts={posts} />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    try {
        const posts = await getJournalPosts(3)

        return {
            props: { posts },
            revalidate: 300
        }
    } catch {
        // The page still renders without the journal strip if the store is unreachable.
        return {
            props: { posts: [] },
            revalidate: 60
        }
    }
}

export default Home
